export const translator = (text, textDefault = "") => {
    if (!text || /^ISA_[A-Za-z0-9_]+$/.test(text)) return textDefault;
    return text;
}